export default __webpack_public_path__ + "static/media/antiques_light.d28ef3f9.png";